<template>
<div id="Thank" class="">
  <b-navbar toggleable="sm" type="light" variant="warning" sticky>
    <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

    <b-navbar-brand><f-icon icon="file-invoice"></f-icon> ใบแจ้งการคืนเงิน (Refund Notice)</b-navbar-brand>

    <b-navbar-nav class="ml-auto">
      <b-button  variant="outline-dark" class="my-2 my-sm-0" @click="$router.push('/')"><f-icon icon="sign-out-alt"></f-icon> Sign Out</b-button>
    </b-navbar-nav>
  </b-navbar>
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col md="11" class="form-login mx-auto mb-3">
        <b-row>
          <b-col class="text-right">
            <!-- <form method="post" action="/action_page.php"></form> -->
            <!-- <b-button v-if="$route.query.userStatus" variant="warning" @click="editData('Request')"><f-icon icon="edit"></f-icon> แก้ไขการเลือกสิทธิ์</b-button> -->
            <!-- <b-button @click="editData('')"><f-icon icon="sign-out-alt"></f-icon> ออกจากระบบ</b-button> -->
            <!-- <b-button size="sm">พิมพ์</b-button> -->
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="6">
            <b-card class="my-2" body-class="p-1" v-if="dataReady">

              <b-card-body class="p-1">
                <div class="text-right">
                  <b-button size="sm" class="mb-2" variant="primary" @click="printThis(urlPDF)"><f-icon icon="file-pdf"></f-icon> บันทึกใบยืนยันสิทธิ PDF</b-button>
                </div>
                <h4>ใบยืนยันสิทธิการคืนเงิน</h4>

                <embed :src="urlPDF" width="100%" height="750px">
              </b-card-body>
            </b-card>  
          </b-col>
        <!-- </b-row>
        <b-row> -->
          <b-col lg="6">
            <b-card class="my-2" body-class="p-1" v-if="dataReady">

              <!-- <b-card-body class="p-1 text-left">
                <p>
                  ข้าพเจ้า {{form.prefix_th}}{{form.displayname_th}} 
                  เลขทะเบียน {{form.username}} 
                </p>
              </b-card-body>

              <b-card-body class="p-1 text-left">
                <template v-if="typeRefund === '1'">
                  <p>&emsp;ข้าพเจ้า <b style=" font-size: 1.2rem; ">ขอยืนยันสิทธิรับส่วนลด</b> ค่าเล่าเรียนและค่าธรรมเนียมการศึกษาสถาบันอุดมศึกษาของรัฐ ตามมาตรการลดภาระค่าใช้จ่ายด้านการศึกษาของนิสิตนักศึกษาในสถาบันอุดมศึกษาภาครัฐและเอกชน ของกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมในภาคเรียนที่ 1/2564 ตามมติคณะรัฐมนตรี และในการนี้ข้าพเจ้ายินยอมให้มหาวิทยาลัย/สถาบันรับเงินที่ภาครัฐสนับสนุน แทนข้าพเจ้าในส่วนที่ข้าพเจ้าพึงได้รับ และออกหลักฐานการรับเงินเพื่อเป็นหลักฐานแก่สำนักบริหารหนี้สาธารณะในนามข้าพเจ้าและสำหรับการตรวจสอบจากหน่วยงานที่เกี่ยวข้องต่อไป</p>
                </template>
                <template v-if="typeRefund === '2'">
                  <p>&emsp;ข้าพเจ้า <b style=" font-size: 1.2rem; ">ไม่ขอรับส่วนลด</b> ค่าเล่าเรียนและค่าธรรมเนียมการศึกษาสถาบันอุดมศึกษาของรัฐของกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมในภาคเรียนที่ 1/2564 โดยขอรับเพียงการช่วยเหลือในส่วนของมหาวิทยาลัย</p>
                </template>
              </b-card-body> -->

              <!-- <b-card-body class="p-1 text-left">
                <small>{{ timenow }}</small>
              </b-card-body> -->

              <b-card-body class="p-1">
                <div class="text-right">
                  <b-button size="sm" class="mb-2" variant="info" @click="printThis(urlPDF2)"><f-icon icon="file-pdf"></f-icon> บันทึกใบแจ้งการคืนเงิน (Refund Notice) PDF</b-button>
                </div>
                <h4>ใบแจ้งการคืนเงิน (Refund Notice)</h4>
                
                <embed :src="urlPDF2" width="100%" height="750px">
              </b-card-body>

              <!-- <b-card-body class="p-1 text-left">
                <small>{{ timenow }}</small>
              </b-card-body> -->

              <b-card-body class="p-1 text-left">

              </b-card-body>
              <!-- <template #footer>
                <b-button href="#" variant="primary">Register</b-button>
              </template> -->
              <!-- <template #footer>
                <b-button variant="outline-secondary" @click="editData" block>ละเบียนบริจาคอุปกรณ์ สำหรับนักศึกษาเรียนออนไลน์เพิ่มเติม <strong>คลิ๊ก!!!</strong></b-button>
              </template> -->
            </b-card>    
          </b-col>
        </b-row>
      
    
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
// import html2canvas from 'html2canvas'
import axios from 'axios' // api

export default {
  name: 'ThankYou',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด 
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    // this.getTimeNow()
  },
  data () {
    return {
      msg: 'Welcome Kathin',
      dataReady: true,
      urlPDF: '',
      urlPDF2: '',
      typeRefund: '',
      timenow: '',
      form: {
        department: '',
        displayname_en: '',
        displayname_th: '',
        faculty: '',
        id_card: '',
        prefix_th: '',
        username: '',
      }
    }
  },
  methods: {
    editData (type) {
      this.$router.push('/'+type)
    },
    getTimeText (dt) {
      const today = new Date(dt)
      const date =
        today.getDate() +
        '/' +
        (today.getMonth() + 1) +
        '/' +
        today.getFullYear()
        
      const time =
        today.getHours() +
        ':' +
        today.getMinutes()

      const dateTime = 'วันที่ ' + date + ' เวลา ' + time + ' น.'
      return dateTime
    },
    getTimeNow () {
      this.timenow = this.getNowGlobal()
    },
    getDataUser () {
      // this.typeRefund = this.$session.get('cft')
      // let receive = 'not_receive'
      // if (this.typeRefund === '1') {
      //   receive = 'receive'
      // }
      let dt = this.getDataSessionUser()
      if (dt) {
        // console.log('getDataUser', dt)
        // this.getDataPrivate(dt)
        
        this.form.displayname_en = dt.displayname_en
        this.form.department = dt.department
        this.form.faculty = dt.faculty
        this.checkData(dt)
      } else {
        this.$router.push('/')
      }
    },
    checkData (dataUser) {
      this.dataReady = false
      let dt = { username: dataUser.username }
      let hk = this.getHashKey(dt)
      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://restapi.tu.ac.th/tu_covid_api/Refund/check_data?username=" + dt.username,
          {
            headers: header
          }
        )
        .then(async (response) => {
          // console.log('registerClaim', response)
          let rs = response.data
          if (rs.status === true) {
            this.typeRefund = rs.statusConfirm
            this.timenow = this.getTimeText(rs.CREATE_DATE)

            let receive = 'Not_confirm'
            let receive_code = 'not_receive'
            if (this.typeRefund === '1') {
              receive = 'Confirm'
              receive_code = 'receive'
            }
            
            let dt_check_user = rs.objStudent

            this.form.displayname_th = dt_check_user.THAINAME
            this.form.prefix_th = dt_check_user.THAITITLE
            this.form.username = dt_check_user.STUDENTID
            this.form.id_card = dt_check_user.TMPCITIZENID

            if (dt_check_user.ciddup === 1) {
              this.$swal({
                titleText: "ลงทะเบียนเรียนหลายหลักสูตร",
                html: 'ตรวจพบนักศึกษาลงทะเบียนเรียนหลายสถาบันหรือหลายหลักสูตร กรุณาลงทะเบียนเลือกหลักสูตรที่ <a target="_blank" href="https://covidfund.cupt.net/register">https://covidfund.cupt.net/register</a>',
                icon: "info"
              })
            }

            let id1 = this.getHashKey(dt, receive)
            let id2 = this.getHashKey(dt, 'refund_notice')
            this.urlPDF = 'https://restapi.tu.ac.th/tu_covid_api/Print_refund/pdf/'+ receive +'?id=' + id1 +'&username=' + dt.username
            this.urlPDF2 = 'https://restapi.tu.ac.th/tu_covid_api/Print_refund_notice/Refund_notice?id=' + id2 +'&sid=' + dt.username
          }
          this.dataReady = true
        })
        .catch((error) => {
          // console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถลงทะเบียนขอรับสิทธิ์ลดหย่อนได้","error")
          this.dataReady = true
        })
    },
    getDataPrivate (dt) {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://restapi.tu.ac.th/api/company/auth/Profile/info?username=' +
          dt.username,
          {
            headers: this.headerPrivateAPI
          }
        )
        .then((response) => {
          // console.log('getDataPrivate', response.data)
          let rs = response.data
          this.form.department = rs.department
          this.form.displayname_en = rs.displayname_en
          this.form.displayname_th = rs.displayname_th
          this.form.faculty = rs.faculty
          this.form.id_card = rs.id_card
          this.form.prefix_th = rs.prefix_th
          this.form.username = rs.username
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('getDataUser error:', error)
          this.dataReady = true
        })
    },
    async printThis(urlPDF) {
      window.open(urlPDF)
      
      // axios
      //   .post(
      //   // .post(
      //     // eslint-disable-next-line quotes
      //     "https://restapi.tu.ac.th/tu_covid_api/Testpdf/Pdf",
      //     // '',
      //     {
      //       headers: this.headerAPI
      //     }
      //   )
      //   .then(async (response) => {
      //     // let rs = response.data

      //     this.dataReady = true
      //   })
      //   .catch((error) => {
      //     // (error.response)
      //     // this.$swal("ผิดพลาด","ไม่สามารถลงทะเบียนบริจาคอุปกรณ์ได้","error")
      //     this.dataReady = true
      //   })
      // console.log("printing..");
      // const el = this.$refs.printcontent;

      // const options = {
      //   type: "dataURL",
      // };
      // const printCanvas = await html2canvas(el, options);

      // const link = document.createElement("a");
      // link.setAttribute("download", "download.png");
      // link.setAttribute(
      //   "href",
      //   printCanvas
      //     .toDataURL("image/png")
      //     .replace("image/png", "image/octet-stream")
      // );
      // link.click();

      // console.log("done");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Refund/Certificate.vue